import React, { useState, useEffect } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import PricingModal from "./PricingModal";
import azureRegions from "../../JSON/AzureRegions.json";
import continentFlags from "../../JSON/ContinentIcon.json";
import regionDisplayNames from "../../JSON/AzureDisplayNames.json";
import { BiLogoPostgresql } from "react-icons/bi";
import { DiMsqlServer } from "react-icons/di";
import { GrMysql } from "react-icons/gr";
import InstanceModal from "./InstanceModal";
import { Dropdown } from "react-bootstrap";
import DeleteRecordModal from "../ViewComponents/DeleteRecordModal";
import { instance } from "three/src/nodes/TSL.js";

const NewDatabaseSQL = () => {
    const { t } = useLanguage();
    const { project_id } = useParams();
    const navigate = useNavigate();
    const [err, setErr] = useState({ message: "", display: false });
    const user_id = sessionStorage.getItem("user_id");
    const [loading, setLoading] = useState(false);
    const [loadingInstances, setLoadingInstances] = useState(true);
    const [loadingPage, setLoadingPage] = useState(true);
    const [interval, setSubsInterval] = useState("monthly");
    const [provider, setProvider] = useState("azure");
    const [dbName, setDbName] = useState("");
    const [description, setDescription] = useState("");
    const [showPricingModal, setShowPricingModal] = useState(false);
    const [selectedRegion, setRegion] = useState("italynorth");
    const [hasPayment, setPayments] = useState(true);
    const [instances, setInstances] = useState([]);
    const [selectedInstance, setSelectedInstance] = useState("");
    const [selectedInstanceSqlType, setSelectedInstanceSqlType] = useState("");
    const [openInstanceModal, setOpenInstanceModal] = useState(false);
    const [instanceName, setInstanceName] = useState("")
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRecordId, setSelectedRecordId] = useState(null);
    const [sqlType, setSqlType] = useState("");

    const goBack = () => {
        navigate(`/project_panel/${project_id}/databases/new_db_type`);
    };

    const NewDb = async () => {
        if (!dbName.trim()) {
            setErr({ message: "Please provide a name for the database", display: true });
            return;
        }

        if (!description.trim()) {
            setErr({ message: "Please provide a description for the database", display: true });
            return;
        }

        if (!selectedInstance.trim()) {
            setErr({ message: "Please select and instance for the database", display: true });
            return;
        }


        setLoading(true);
        let data = {
            user_id,
            project_id,
            instance_id: selectedInstance,
            db_name: dbName,
            db_desc: description,
            provider,
            selectedRegion,
            interval,
            db_type: "sql",
            sql_type: sqlType
        };

        try {
            setErr({ message: "", display: false });
            const response = await fetch("https://backend.erioon.com/create_db_sql", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });

            setLoading(false);

            if (response.ok) {
                const result = await response.json();
                const db_id = result.db_id;
                navigate(`/project_panel/${project_id}/databases/${db_id}/data`);
            } else {
                setErr({ message: "An error occurred during the creation of the database", display: true });
            }
        } catch (error) {
            setLoading(false);
        }
    };


    const fetchInstances = async () => {
        setLoadingInstances(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_instances", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ user_id, project_id }),
            });

            if (response.ok) {
                const result = await response.json();
                const apisData = result.instances || {};
                const recordsArray = Object.values(apisData);
                if (recordsArray.length == 0) {
                    setSelectedInstance("");
                    setSelectedInstanceSqlType("")
                    setInstanceName("");
                    setSqlType("");
                }

                setInstances(recordsArray);
            } else {
                console.error("Failed to fetch instances", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching instances", error);
        }
    };

    const fetchUserData = async () => {
        setLoadingPage(true);
        try {
            const response = await fetch('https://backend.erioon.com/get_specific_data', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ user_id }),
            });

            if (!response.ok) throw new Error('Failed to fetch user data');

            const data = await response.json();
            setPayments(!!data.payment_method);
        } catch (error) {
            console.error("Error fetching user data:", error);
        } finally {
            setTimeout(() => {
                setLoadingPage(false);
            }, 800);
        }
    };

    useEffect(() => { fetchUserData(); fetchInstances() }, [provider]);
    useEffect(() => {
        const hasCreating = instances.some((instance) => instance.status === "creating");

        let intervalId;

        if (hasCreating) {
            setLoadingInstances(true)
            intervalId = setInterval(() => {
                fetchInstances();
            }, 5000);
        } else {
            setTimeout(() => {
                setLoadingInstances(false)
            }, 800);
        }

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [instances]);



    const handleCloseModal = () => {
        setShowDeleteModal(false);
        setSelectedRecordId(null);
    };

    const handleDeleteClick = (accID) => {
        setSelectedRecordId(accID);
        setShowDeleteModal(true);
    };


    if (loadingPage) {
        return (
            <div className="loading_new_db_cont">
                <div className="loading_resources_new fade-in">
                    <div className="loading_resources_new_main"></div>
                    <div className="loading_resources_new_main"></div>
                </div>
                <div className="loading_resume_new fade-in">
                    <div className="loading_resume_new_main"></div>
                </div>
            </div>
        );
    }


    return (
        <div>
            <div className="new_section_main_view fade-in">
                <p className="new_section_main_view_title">
                    <i className="fa-solid fa-chevron-left" onClick={goBack}></i> New database - SQL
                </p>
                <p className="new_section_main_view_subtitle">
                    Complete all the fields and create the database
                </p>

                {(!hasPayment) && (
                    <div className="no_payment_method_db fade-in">
                        <p>To proceed, please add a valid payment method to your account.</p>
                        <button className="add_payment_btn" onClick={() => navigate("/control_panel/billing")}>
                            <i className="fa-solid fa-plus"></i> Add payment method
                        </button>
                    </div>
                )}

                <div className="new_section_main_input_cont fade-in">
                    <div className="new_section_main_input_container">

                        <p className="db_title">
                            Choose or create a new instance
                            <button className="reload_billing_btn" onClick={fetchInstances}>
                                {loadingInstances ? (
                                    <>
                                        <i className="creating_instance fa-solid fa-rotate"></i> Loading
                                    </>
                                ) : (
                                    <>
                                        <i className="active_instance fa-solid fa-rotate"></i> Refresh
                                    </>
                                )}
                            </button>
                        </p>
                        <div className="instance_cont">
                            {instances.length == 0 ? (
                                <div className={`instance_card_btn_empty ${hasPayment ? "" : "instance_card_btn_empty_disabled"}`} onClick={() => {
                                    if (hasPayment) {
                                        setOpenInstanceModal(true);
                                    }
                                }}>
                                    <div className="instance_card_btn_empty_cont">
                                        <p className="instance_title">Create a new instance</p>
                                        <i className="fa-solid fa-plus"></i>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {instances.map((instance) => (
                                        <div
                                            key={instance._id}
                                            className={`instance_card 
  ${selectedInstance === instance._id ? "selected" : ""} 
  ${instance.status === "creating" ? "creating_instance_card" :
                                                    instance.status === "deleting" ? "deleting_instance_card" : ""}`}
                                            onClick={() => {
                                                if (instance.status !== "creating" && instance.status !== "deleting") {
                                                    setSelectedInstance(instance._id);
                                                    setSelectedInstanceSqlType(instance.sql_type)
                                                    setInstanceName(instance.instance_name);
                                                    setSqlType(instance.sql_type);
                                                }
                                            }}
                                        >
                                            <div>
                                                <p className="instance_title">
                                                    {instance.instance_name}
                                                    <i>
                                                        {instance.sql_type == "sqlserver" ? (
                                                            <DiMsqlServer />
                                                        ) : instance.sql_type == "postgresql" ? (
                                                            <BiLogoPostgresql />
                                                        ) : (
                                                            <GrMysql />
                                                        )}
                                                    </i>
                                                </p>
                                                <p className="instance_description">{instance.db_desc}</p>
                                            </div>

                                            <div className="footer_items_org">
                                                <div className="footer_items_org_cont">
                                                    <div className="footer_items_org_cont_icons">
                                                        {instance.status == "creating" ? (
                                                            <i className="creating_instance fa-solid fa-rotate"></i>
                                                        ) : instance.status == "failed" ? (
                                                            <i className="failed_instance fa-solid fa-triangle-exclamation"></i>
                                                        ) : instance.status == "deleting" ? (
                                                            <i className="failed_instance fa-solid fa-rotate"></i>
                                                        ) : (
                                                            <i className="active_instance fa-solid fa-circle-check"></i>
                                                        )}
                                                    </div>
                                                    <p className="selected_region_footer">{regionDisplayNames[instance.selected_region]}</p>
                                                </div>
                                                {(instance.status != "creating" && instance.status != "deleting") && (
                                                    <Dropdown>
                                                        <div className="property_btn_action_toggle">
                                                            <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                                                <i className="fa-solid fa-ellipsis-vertical"></i>
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu className="custom-dropdown-menu">

                                                                <Dropdown.Item
                                                                    className="drop_down_item delete"
                                                                    onClick={() => handleDeleteClick(instance._id)}
                                                                >
                                                                    <i className="fa-solid fa-trash"></i> {t.delete}
                                                                </Dropdown.Item>

                                                            </Dropdown.Menu>
                                                        </div>
                                                    </Dropdown>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                    <div className="instance_card_btn" onClick={() => setOpenInstanceModal(true)}>
                                        <div className="instance_card_new_btn"><i className="fa-solid fa-plus"></i></div>
                                    </div>
                                </>
                            )}


                        </div>


                    </div>

                    <div className={`${selectedInstanceSqlType ? "cost_preview_container" : "cost_preview_container_closed"}`}>
                        <div className="cost_preview_cont">
                            {selectedInstanceSqlType == "sqlserver" ? (
                                <p className="new_section_main_input_hint_title">
                                    From $0.85/h <span className="price_info" onClick={() => setShowPricingModal(true)}><i className="fa-solid fa-info"></i></span>
                                </p>
                            ) : (
                                <p className="new_section_main_input_hint_title">
                                    From $0.30/h <span className="price_info" onClick={() => setShowPricingModal(true)}><i className="fa-solid fa-info"></i></span>
                                </p>
                            )}

                            <p className="new_section_main_input_hint_description">
                                Price based on the standard erioon pay-as-you-go pricing.
                            </p>
                        </div>

                        <div className="preview_cont_db">
                            {selectedInstanceSqlType == "sqlserver" ? (
                                <div className="review_cont">
                                    <p className="review_cont_title">Resume for Erioon SQL server DB</p>
                                    <p className="review_cont_data">This serverless SQL instance can automatically scale up to 500GB of storage and 4 vCores, and will pause when idle to minimize costs.</p>
                                    <p className="review_cont_data">Storage capacity <span>max 500GB</span></p>
                                    <p className="review_cont_data">Operations <span>Up to 3000 IOPS per vCore</span></p>
                                    <p className="review_cont_data">Backup <span>Geo-redundant backups</span></p>
                                    <p className="review_cont_data">Scalable <span><i className="fa-solid fa-check"></i></span></p>
                                    <p className="review_cont_data">Auto-pause <span>After 1H of inactivity</span></p>

                                    <div className="label_input_section_db">
                                        <label>Instance *</label>
                                        <p className="review_cont_data"><span>{instanceName || <div className="loading_span"></div>}</span></p>
                                    </div>

                                    <div className="label_input_section_db">
                                        <label>Database name *</label>
                                        <input value={dbName} onChange={(e) => setDbName(e.target.value)} placeholder="Main database" />
                                    </div>

                                    <div className="label_input_section_db">
                                        <label>Description *</label>
                                        <input value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Datasets of customers and products..." className="description_area_input" />
                                    </div>
                                </div>
                            ) : (
                                <div className="review_cont">
                                    <p className="review_cont_title">Resume for Erioon PostgreSQL DB</p>
                                    <p className="review_cont_data">This PostgreSQL instance delivers seamless scalability, supporting up to 32 TB of storage and 64 vCores.</p>
                                    <p className="review_cont_data">Storage capacity <span>max 32TB</span></p>
                                    <p className="review_cont_data">Operations <span>Up to 7500 IOPS per vCore</span></p>
                                    <p className="review_cont_data">Backup <span>Zone redundant backups</span></p>
                                    <p className="review_cont_data">Scalable <span><i className="fa-solid fa-check"></i></span></p>
                                    <p className="review_cont_data">Auto-pause <span><i className="fa-solid fa-x"></i></span></p>

                                    <div className="label_input_section_db">
                                        <label>Instance *</label>
                                        <p className="review_cont_data"><span>{instanceName || <div className="loading_span"></div>}</span></p>
                                    </div>

                                    <div className="label_input_section_db">
                                        <label>Database name *</label>
                                        <input value={dbName} onChange={(e) => setDbName(e.target.value)} placeholder="Main database" />
                                    </div>

                                    <div className="label_input_section_db">
                                        <label>Description *</label>
                                        <input value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Datasets of customers and products..." className="description_area_input" />
                                    </div>
                                </div>
                            )}


                            <ErrorMessage err={err} />
                            <button
                                disabled={!hasPayment || loading}
                                className={`save_btn_db ${!hasPayment ? "save_btn_db_disabled" : ""}`}
                                onClick={NewDb}
                            >
                                {loading ? <Spinner loading={loading} /> : <><i className="fa-solid fa-plus"></i> Create database</>}
                            </button>
                        </div>
                    </div>

                    <PricingModal show={showPricingModal} handleClose={() => setShowPricingModal(false)} pricing_data={selectedInstanceSqlType} db_type={"SQL"} />
                    <InstanceModal show={openInstanceModal} handleClose={() => setOpenInstanceModal(false)} azureRegions={azureRegions} selectedRegion={selectedRegion} setRegion={setRegion} continentFlags={continentFlags} regionDisplayNames={regionDisplayNames} fetchInstances={fetchInstances} />
                    <DeleteRecordModal
                        show={showDeleteModal}
                        handleClose={handleCloseModal}
                        recordObject={instances.find((instance) => instance._id === selectedRecordId)}
                        fetchRecords={fetchInstances}
                        endpoint={"delete_instance"}
                        record_type={selectedRecordId}
                        message="This action CANNOT be undone later. This instance will be deleted and all the data will be removed permanently."
                    />
                </div>
            </div>
        </div>
    );
};

export default NewDatabaseSQL;
